module.exports = __webpack_public_path__ + "static/img/xs1-6.a923bb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xs1-6.png
// module id = 801
// module chunks = 0